import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { PerformanceTooltip } from "ui/components/panels/canvas/overlay-elements/tooltip-components/performance-tooltip";
import { useNumberConversion } from "hooks/number-conversion";
import { Unit } from "utility/number";
import { selectors, useAppSelector } from "store";
/**
 * Summary card shown in the component data panel that splits the total vacuum
 * system volume into the part contributed by the catalog components and the
 * part contributed by the tubing, so the user can see where the volume comes
 * from. Tube volume is a system-wide quantity (in a central system the tubing
 * forms one shared tree), so it is shown here as a total rather than per cup.
 */
export var VolumeBreakdown = function () {
    var t = useTranslation().t;
    var convertNumber = useNumberConversion();
    var componentVolume = useAppSelector(selectors.selectVacuumSystemComponentVolume);
    var tubingVolume = useAppSelector(selectors.selectVacuumSystemTubingVolume);
    var totalVolume = useAppSelector(selectors.selectVacuumSystemVolume);
    return (_jsx(PerformanceTooltip, { title: t("canvas.system_volume_title"), showValidityMessage: false, children: _jsxs(_Fragment, { children: [_jsx("br", {}), "".concat(t("canvas.component_volume"), ": ").concat(convertNumber(componentVolume, Unit.L).formatted), _jsx("br", {}), "".concat(t("canvas.tubing_volume"), ": ").concat(convertNumber(tubingVolume, Unit.L).formatted), _jsx("br", {}), "".concat(t("canvas.total_volume"), ": ").concat(convertNumber(totalVolume, Unit.L).formatted)] }) }));
};
